import { PageReservationsViewsDesktop } from './page_reservations_views_desktop';

export const PageReservations = () => <PageReservationsViewsDesktop />;
